<template>
  <main class="w-100">

    <LoadingSpinner v-if="!completeLoading" />

    <!-- Vista Desktop -->
    <div v-else class="row my-4 d-none d-lg-flex">
      <div
        v-for="col in [1,2,3,4]"
        :key="'col-'+col"
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 m-0 p-2"
      >
        <div
          v-for="item in columns[col]"
          :key="item.id"
          class="card shadow px-3 py-3 mb-3"
        >
          <div class="h6 font-weight-bold">
            {{ item.label }}

            <button v-if="!item.isLoading" class="ml-2 btn btn-sm" @click="getDataCustom(item.id)">
              <span class="icon-repeat"></span>
            </button>
            <span v-else class="icon-spinner ml-2"></span>
          </div>

          <ul v-for="(option, index) of item.detail" :key="index">
            <li class="my-1">
              {{ option.label }} :
              <template v-if="option.filter == 'non_prospecting_emails_30d' || option.filter == 'subscribers_without_cold_tasks_done' || option.filter == 'billed_without_running_order' || option.filter == 'deferred_without_kickoff_date' || option.filter == 'signed_15d_without_kickoff_date' || option.filter == 'kickoff_overdue_without_invoice' || option.filter == 'flips_next_7_days'">
                <span v-if="option.variation"
                  :class="{
                    'badge-success rounded px-1 m-2': option.variation == 'up',
                    'badge-secondary rounded px-1 m-2': option.variation == 'down',
                    'badge-secondary rounded px-1 m-2': option.variation == 'ok',
                    'badge-danger rounded px-1 m-2': option.variation == 'danger'
                  }"
                >
                  {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                </span>
                <ul v-if="option.values && option.values.length" class="ml-3 mt-1 mb-0 list-unstyled">
                  <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                    {{ value.name }}:
                    <span class="badge rounded px-1 ml-1" :class="parseInt(value.total, 10) > 0 ? 'badge-danger' : 'badge-secondary'">
                      {{ parseInt(value.total, 10) }}
                    </span>
                  </li>
                </ul>
              </template>

              <template v-else-if="item.id == 'accountManagement' && option.filter == 'com'">
                <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                  {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                </span>
                <ul v-if="option.values && option.values.length" class="ml-3 mt-1 mb-0 list-unstyled">
                  <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                    {{ value.name }}:
                    <span class="badge rounded px-1 ml-1" :class="parseInt(value.total, 10) > 100 ? 'badge-danger' : 'badge-secondary'">
                      {{ parseInt(value.total, 10) }}
                    </span>
                  </li>
                </ul>
              </template>

              <template v-else-if="item.id == 'accountManagement' && option.filter == 'signed_client_mailboxes_5d'">
                  <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                    {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                  </span>
                  <ul v-if="option.filter == 'signed_client_mailboxes_5d' && option.values">
                    <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                      {{ value.account_manager }}: {{ value.total }}

                    </li>
                  </ul>
              </template>

              <template v-else-if="item.id == 'accountManagement' && option.filter == 'signed_clients_not_lunched_45d'">
                  <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                    {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                  </span>
                  <ul v-if="option.filter == 'signed_clients_not_lunched_45d' && option.values">
                    <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                      {{ value.account_manager }}: {{ value.total }}

                    </li>
                  </ul>
              </template>


              <template v-else-if="item.id == 'accountManagement' && option.filter == 'cold_call_client_0_bookers'">
                  <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                    {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                  </span>
                  <!-- <ul v-if="option.filter == 'cold_call_client_0_bookers' && option.values">
                    <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                      {{ value.account_manager }}: {{ value.total }}

                    </li>
                  </ul>               -->
              </template>

              <template v-else-if="option.values">
                <ul>
                  <li v-for="(value, index) of option.values" :key="index">
                    {{ value.name }}
                    <span class="badge-danger rounded px-2 m-2">{{ value.total }}</span>
                  </li>
                </ul>
              </template>

              <template v-else>
                <span :class="{'text-danger': option.task_type_id || option.totalDanger }">

                <span v-if="option.valueTotal && option.valueTotal == 'noData'">
                  0
                </span>

                <span v-else>
                  <span v-if="option.variation"
                        :class="{
                        'badge-success rounded px-1 m-2': option.variation == 'up',
                        'badge-secondary rounded px-1 m-2': option.variation == 'down',
                        'badge-success rounded px-1 m-2': option.variation == 'ok',
                        'badge-danger rounded px-1 m-2': option.variation == 'danger'
                        }"
                      >
                        <template v-if="option.filter == 'mailinblack_done'">
                          <span :class="formatColor(option.valueTotal, item.id, option.filter)">
                            {{ option.valueTotal }}
                            <span class="ml-0" v-if="(option.valueTotal || option.value) && option.symbol">
                              {{  option.symbol  }}
                            </span>
                          </span>
                        </template>
                        <template v-else-if="item.id != 'operations'">
                           {{ option.valueTotal }}
                          <span class="ml-0" v-if="(option.valueTotal || option.value) && option.symbol">
                            {{  option.symbol  }}
                          </span>
                        </template>


                    </span>

                    <span
                        v-if="item.id == 'operations' && option.filter !='mailinblack_done'"
                        class="rounded px-1 ml-0"
                        :class="formatColor(option.valueTotal, item.id, option.filter)"
                      >
                        <span v-if="option.symbolBefore && option.symbol">{{ option.symbol }}</span>{{ option.valueTotal }}
                    </span>
                </span>

                <span class="ml-1" v-if="option.type == 'percentage'">
                  %
                </span>
                <!-- <span class="ml-0" v-if="(option.valueTotal || option.value) && option.symbol">
                  {{  option.symbol  }}
                </span> -->
                </span>

                <template v-if="!option.task_type_id && option.type != 'percentage' && option.type != 'avg_total'">

                <span v-if="option.loading">
                  <Loadingcircle :paramloading="paramloading" />
                </span>

                <span v-else>

                  <span  v-if="option.value && option.value != 'noData'">
                    <span :class="{'text-prrimary': option.value < 0, 'text-prrimary': option.value > 0 }">
                      <span v-if="option.value > 0"  class="icon-arrow-up ml-2"></span>
                      <span v-if="option.value < 0"  class="icon-arrow-down ml-2"></span>
                      <span v-if="option.type == 'date'" :class="validDate(option.value, option.filter)">{{ option.value }}</span>
                      <span v-else> {{ option.value  }}  </span>
                      <span v-if="option.type != 'date'">%</span>
                    </span>

                  </span>

                  <span v-else-if="option.value =='noData'">0</span>
                  <span v-else></span>
                </span>
              </template>
            </template>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Vista Mobile - Carousel -->
    <div
      v-if="completeLoading"
      class="mobile-carousel-container d-lg-none"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <!-- Container del slide -->
      <div
        class="carousel-track"
        :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
      >
        <div
          v-for="item in data"
          :key="'mobile-' + item.id"
          class="carousel-slide"
        >
          <div class="card shadow px-3 py-3 mobile-card">
            <div class="h5 font-weight-bold card-header-mobile">
              {{ item.label }}
              <button class="ml-2 btn btn-sm" @click="getDataCustom(item.id)">
                <span class="icon-spinner"></span>
              </button>
            </div>

            <div class="card-content-scroll">
              <ul v-for="(option, index) of item.detail" :key="index">
                <li class="my-2">
                  {{ option.label }} :
                  <template v-if="option.filter == 'non_prospecting_emails_30d' || option.filter == 'subscribers_without_cold_tasks_done' || option.filter == 'billed_without_running_order' || option.filter == 'deferred_without_kickoff_date' || option.filter == 'signed_15d_without_kickoff_date' || option.filter == 'kickoff_overdue_without_invoice' || option.filter == 'flips_next_7_days'">
                    <span v-if="option.variation"
                      :class="{
                        'badge-success rounded px-1 m-2': option.variation == 'up',
                        'badge-secondary rounded px-1 m-2': option.variation == 'down',
                        'badge-success rounded px-1 m-2': option.variation == 'ok',
                        'badge-danger rounded px-1 m-2': option.variation == 'danger'
                      }"
                    >
                      {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                    </span>
                    <ul v-if="option.values && option.values.length" class="ml-3 mt-1 mb-0 list-unstyled">
                      <li v-for="(value, vIdx) of option.values" :key="vIdx" class="my-1">
                        {{ value.name }}:
                        <span class="badge rounded px-1 ml-1" :class="parseInt(value.total, 10) > 0 ? 'badge-danger' : 'badge-secondary'">
                          {{ parseInt(value.total, 10) }}
                        </span>
                      </li>
                    </ul>
                  </template>

                  <template v-else-if="item.id == 'accountManagement' && option.filter == 'com'">
                    <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                      {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                    </span>
                    <ul v-if="option.values && option.values.length" class="ml-3 mt-1 mb-0 list-unstyled">
                      <li v-for="(value, vIdx) of option.values" :key="vIdx" class="my-1">
                        {{ value.name }}:
                        <span class="badge rounded px-1 ml-1" :class="parseInt(value.total, 10) > 100 ? 'badge-danger' : 'badge-secondary'">
                          {{ parseInt(value.total, 10) }}
                        </span>
                      </li>
                    </ul>
                  </template>

                  <template v-else-if="item.id == 'accountManagement' && option.filter == 'signed_client_mailboxes_5d'">
                    <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                      {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                    </span>
                    <ul v-if="option.filter == 'signed_client_mailboxes_5d' && option.values" class="ml-3 mt-1 mb-0 list-unstyled">
                      <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                        {{ value.account_manager }}: {{ value.total }}
                      </li>
                    </ul>
                  </template>

                  <template v-else-if="item.id == 'accountManagement' && option.filter == 'signed_clients_not_lunched_45d'">
                    <span class="badge rounded px-1 ml-1" :class="formatColor(option.valueTotal, item.id, option.filter)">
                      {{ option.valueTotal != null && option.valueTotal != 'noData' ? parseInt(option.valueTotal, 10) : 0 }}
                    </span>
                    <ul v-if="option.filter == 'signed_clients_not_lunched_45d' && option.values" class="ml-3 mt-1 mb-0 list-unstyled">
                      <li v-for="(value, idx) of option.values" :key="idx" class="my-1">
                        {{ value.account_manager }}: {{ value.total }}
                      </li>
                    </ul>
                  </template>

                  <template v-else-if="option.values">
                    <ul class="ml-3 mt-1 mb-0 list-unstyled">
                      <li v-for="(value, vIndex) of option.values" :key="vIndex" class="my-1">
                        {{ value.account_manager || value.name }}:
                        <span class="badge-danger rounded px-2 ml-1">{{ value.total }}</span>
                      </li>
                    </ul>
                  </template>

                  <template v-else>
                    <span :class="{'text-danger': option.task_type_id || option.totalDanger }">

                    <span v-if="option.valueTotal && option.valueTotal == 'noData'">
                      0
                    </span>

                    <span v-else>
                      <span v-if="option.variation"
                            :class="{
                            'badge-success rounded px-1 m-2': option.variation == 'up',
                            'badge-secondary rounded px-1 m-2': option.variation == 'down',
                            'badge-success rounded px-1 m-2': option.variation == 'ok',
                            'badge-danger rounded px-1 m-2': option.variation == 'danger'
                            }"
                          >
                            <template v-if="option.filter == 'mailinblack_done'">
                              <span :class="formatColor(option.valueTotal, item.id, option.filter)">
                                {{ option.valueTotal }}
                                <span class="ml-0" v-if="(option.valueTotal || option.value) && option.symbol">
                                  {{  option.symbol  }}
                                </span>
                              </span>
                            </template>
                            <template v-else-if="item.id != 'operations'">
                               {{ option.valueTotal }}
                              <span class="ml-0" v-if="(option.valueTotal || option.value) && option.symbol">
                                {{  option.symbol  }}
                              </span>
                            </template>
                        </span>

                        <span
                            v-if="item.id == 'operations' && option.filter !='mailinblack_done'"
                            class="rounded px-1 ml-1"
                            :class="formatColor(option.valueTotal, item.id, option.filter)"
                          >
                            <span v-if="option.symbolBefore && option.symbol">{{ option.symbol }}</span>{{ option.valueTotal }}
                        </span>
                    </span>

                    <span class="ml-1" v-if="option.type == 'percentage'">
                      %
                    </span>
                    </span>

                    <template v-if="!option.task_type_id && option.type != 'percentage' && option.type != 'avg_total'">

                    <span v-if="option.loading">
                      <Loadingcircle :paramloading="paramloading" />
                    </span>

                    <span v-else>

                      <span v-if="option.value && option.value != 'noData'">
                        <span :class="{'text-prrimary': option.value < 0, 'text-prrimary': option.value > 0 }">
                          <span v-if="option.value > 0" class="icon-arrow-up ml-2"></span>
                          <span v-if="option.value < 0" class="icon-arrow-down ml-2"></span>
                          <span v-if="option.type == 'date'" :class="validDate(option.value, option.filter)">{{ option.value }}</span>
                          <span v-else> {{ option.value  }}  </span>
                          <span v-if="option.type != 'date'">%</span>
                        </span>
                      </span>

                      <span v-else-if="option.value =='noData'">0</span>
                      <span v-else></span>
                    </span>
                  </template>
                </template>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { campaignsService, monitorService, usersService, bookersService, workspaceService, targetsService } from '@/_services';
import Loadingcircle from  "@/components/Common/Loadingcircle.vue";


export default {
  name: "Metrics",
  components: {
    LoadingSpinner,
    Loadingcircle
  },
  props: {
    startDate: {
      type: String,
      default: "0",
    },
    endDate: {
      type: String,
      default: "0",
    },
    clientId: {
      type: String,
      default: null,
    },
    getDataMetrics: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    getDataMetrics() {
      this.completeLoading = true
      this.data.forEach( el => {
        el.detail.forEach( e => {
          e.value = null
          e.valueTotal = null
          e.loading = false
        })
      })
      //this.startProcessing();
    },
    loadingStats: function () {
      this.loadData();
    },
  },
  computed: {
    ...mapState({
      loading: (state) => state.campaigns.loading,
      campaigns: (state) => state.campaigns.alldashboard.data,
      currentUser: (state) => state.authentication.user,
      loadingStats: (state) => state.campaigns.loadingStats,
      stats: (state) => state.campaigns.stats.data,
    }),
    valueTotal () {
      return (valueTotal) => {
        return (valueTotal && valueTotal != 'noData') ? valueTotal : ''
      }
    },

     columns() {
      const cols = { 1: [], 2: [], 3: [] , 4: [] };
      for (const it of this.data) {
        const c = it.column || 1;
        if (!cols[c]) cols[c] = [];
        cols[c].push(it);
      }
      return cols;
    },

    validDate () {
      return (value, item) => {

        const itemsToCheck5Days = [
          'status-onboarding', 'screening-3day','status-standby',
          'status-stopped'
        ]

        const itemsToCheck3Days = [
          'absent-meeting-treatment'
        ]

        const itemsToCheck30Days = [
          'performance-alert-1', 'performance-alert-2',
          'consistency-alert-1', 'lost-meeting-alert', 'pickup-alert'
        ]

        let daysAgo = 1

        if(itemsToCheck3Days.includes(item)){

          daysAgo = 3

          const date = moment(value).startOf('day');
          const dateToCompare = moment().subtract(daysAgo, 'days').startOf('day');

          return (date.isBefore(dateToCompare)) ? 'text-danger' : 'text-primary'

        }

        if(itemsToCheck5Days.includes(item)){

          daysAgo = 5

          const date = moment(value).startOf('day');
          const dateToCompare = moment().subtract(daysAgo, 'days').startOf('day');

          return (date.isBefore(dateToCompare)) ? 'text-danger' : 'text-primary'

        }

        if(itemsToCheck30Days.includes(item)){

        daysAgo = 30

        const date = moment(value).startOf('day');
        const dateToCompare = moment().subtract(daysAgo, 'days').startOf('day');

        return (date.isBefore(dateToCompare)) ? 'text-danger' : 'text-primary'

        }

        const date = moment(value).startOf('day');
        const dateToCompare = moment().subtract(daysAgo, 'days').startOf('day');

        return (date.isBefore(dateToCompare)) ? 'text-danger' : 'text-primary'


      }
    },

    formatColor () {
      return (valueTotal, id, filter = false) => {
        if(id == 'accountManagement' && (filter == 'com')) {
          return 'badge-secondary'
        }
        if(id == 'accountManagement' && (filter == 'signed_client_mailboxes_5d' || filter == 'signed_clients_not_lunched_45d' || filter == 'cold_call_client_0_bookers')) {
          return (!valueTotal) ? 'badge-secondary' : 'badge-secondary'
        }
        if(id == 'operations'){
          if(filter == 'mailinblack_done') {
            const horaFrancia = parseInt(new Date().toLocaleString('fr-FR', {
                timeZone: 'Europe/Paris',
                hour: '2-digit',
                hour12: false
              }));
            //console.log("Aqui",horaFrancia);
            return (valueTotal < 80 && horaFrancia >= 17) ? 'badge-danger' : 'badge-secondary'
          } else if(filter == 'zapmail_wallet_balance') {
            return (valueTotal < 300) ? 'badge-danger' : 'badge-secondary'
          } else if(filter == 'mailboxes_unassigned_google' || filter == 'mailboxes_unassigned_microsoft') {
            return (valueTotal < 36) ? 'badge-danger' : 'badge-secondary'
          } else {
            return (valueTotal > 0) ? 'badge-danger' : 'badge-secondary'
          }
        }
        return (valueTotal > 0) ? 'badge-success' : 'badge-secondary'
      }
    },

  },
  data() {
    return {
      shortInterval: 40000,    // 40 segundos
      longInterval: 55 * 60 * 1000, // 55 minutos

      destroyProcess: false,
      paramloading: {
        width: '18px',
        height: '18px',
        color: '#5054EB'
      },
      completeLoading: false,
      // Mobile carousel
      currentSlide: 0,
      touchStartX: 0,
      touchEndX: 0,
      minSwipeDistance: 50,
      data: [

          //Sendings
          {
          id: 'sendings',
          label: 'Sendings',
          column: 1,
          isLoading: true,
          detail: [
            {
              label: 'Total email sent',
              filter: 'sent',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              currentMonth: true,
              useStatmetrics: true,
              decimals: false,
              variation:'ok'
            },
            {
              label: 'New prospects first time (yesterday)',
              filter: 'newprospects_first_prctg',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              currentMonth: true,
              useStatmetrics: true,
              decimals: false,
              variation:'ok'
            },
            {
              label: 'Bounce rate',
              filter: 'bounce_prc',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              currentMonth: true,
              useStatmetrics: true,
              decimals: 2,
              symbol: '%',
              variation:'ok'
            },
            {
              label: 'PEAs',
              filter: 'accounts_sent',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              variation:'ok'
            },
            {
              label: 'Email sent / PEA',
              filter: 'email_sent_acc',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              variation:'ok'
            },
            {
              label: 'Full Enrich Credits',
              filter: 'fullEnrichCredits',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation: 'ok',
            },
            // {
            //   label: 'Orders without tasks',
            //   filter: 'orders_without_tasks',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   decimals: false,
            // },
          //  {
          //     label: 'Contact supply issues',
          //     filter: 'critical_contact_issues',
          //     type: 'total',
          //     loading: false,
          //     valueTotal: null,
          //     value: null,
          //     task_type_id: 14
          //   },

            // {
            //   label: 'Avg waiting to be enriched contact',
            //   filter: 'avg_waiting_to_be_enriched_contact',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   totalDanger: true
            // },
          ]
        },

         //Crons
         {
          id: 'crons',
          label: 'Crons',
          column: 2,
          isLoading: true,
          detail: [
            {
              label: 'Get bookers call audios',
              filter: 'ringover-get-call-info',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Get bookers call transcript',
              filter: 'ringover-get-transcription',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Get bookers quizz scores',
              filter: 'get-booker-score',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Get bookers interviews',
              filter: 'get-booker-Interactions',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Activation AI prompt transcripts analisis',
              filter: 'check-transcription',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Activacion AI prompt script generation',
              filter: 'bdr-generate-script-v2',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker new account',
              filter: 'account-created',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Change to rejected',
              filter: 'status-rejected',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            // {
            //   label: 'Last email booker Change to onboarding',
            //   filter: 'status-onboarding',
            //   type: 'date',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   useStatmetrics: true,
            // },
            {
              label: 'Last email booker screening follow-up',
              filter: 'screening-3day',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Change to Standby status',
              filter: 'status-standby',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Change to stopped status',
              filter: 'status-stopped',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Performance alert 1',
              filter: 'performance-alert-1',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Performance alert 2',
              filter: 'performance-alert-2',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Consistency alert 1',
              filter: 'consistency-alert-1',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Lost meeting alert',
              filter: 'lost-meeting-alert',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last email booker Pickup alert',
              filter: 'pickup-alert',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Last AbsentMeetingT date',
              filter: 'absent-meeting-treatment',
              type: 'date',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
            {
              label: 'Total AbsentMeetingT last date',
              filter: 'total-absent-meeting-treatment',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              useStatmetrics: true,
            },
          ]
        },

         // Booker recruitment
         {
          id: 'accountManagement',
          label: 'Account Management',
          column: 3,
          isLoading: true,
          detail: [
            {
              label: 'COM > 72',
              filter: 'com',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 21,
              decimal: false,
              decimals: false,
            },
            {
              label: 'Purchased domains',
              filter: 'purchased_domains',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              task_type_id: 0,
              decimals: false,
              useStatmetrics: true,
              variation: 'ok'
            },
            {
              label: 'Purchased email licenses',
              filter: 'purchased_mailboxes',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              task_type_id: 0,
              decimals: false,
              useStatmetrics: true,
              variation: 'ok'
            },
            {
              label: 'Non prospecting emails w/o campaign > 30d',
              filter: 'non_prospecting_emails_30d',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Subscribers without cold tasks done < 100',
              filter: 'subscribers_without_cold_tasks_done',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Billed without running order',
              filter: 'billed_without_running_order',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Deferred kickoff_30 without kickoff date',
              filter: 'deferred_without_kickoff_date',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'V2 signed > 15d without kickoff date',
              filter: 'signed_15d_without_kickoff_date',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Kickoff + 1 month without invoice',
              filter: 'kickoff_overdue_without_invoice',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Flips next 7 days (kickoff + 1 month)',
              filter: 'flips_next_7_days',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Signed client (Validation, Preparation) w/o mailboxes > 5d ',
              filter: 'signed_client_mailboxes_5d',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Signed clients (Preparation) not launched > 45d',
              filter: 'signed_clients_not_lunched_45d',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Cold call client w/ 0 bookers',
              filter: 'cold_call_client_0_bookers',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              values: null,
              task_type_id: 0,
              decimal: false,
              decimals: false,
              variation: 'ok'
            },
          ]
        },


        //Operations
        {
          id: 'operations',
          label: 'Operations',
          column: 4,
          isLoading: true,
          detail: [
          {
            label: 'Zapmail Wallet Balance',
            filter: 'zapmail_wallet_balance',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            symbol: '$',
            symbolBefore: true,
            decimals: 2,
            variation: 'ok',
          },
          // {
          //   label: 'Mailboxes unassigned Google',
          //   filter: 'mailboxes_unassigned_google',
          //   type: 'total',
          //   loading: false,
          //   valueTotal: null,
          //   value: null,
          //   decimals: false,
          //   variation: 'ok',
          // },
          {
            label: 'Mailboxes unassigned Microsoft',
            filter: 'mailboxes_unassigned_microsoft',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            decimals: false,
            variation: 'ok',
          },
          {
            label: 'Mailinblack Done Rate',
            filter: 'mailinblack_done',
            type: 'average',
            loading: false,
            valueTotal: null,
            value: null,
            useStats: true,
            symbol: '%',
            yesterday: true,
            variation: 'ok',
            min: 80
          },
          {
            label: 'Emails not tagged > 24h',
            filter: 'emails_not_tagged',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 0,
            decimal: false
          },
          {
            label: 'Copywriting open L1 ',
            filter: 'copywriting_open_l1',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 18,
            decimal: false
          },
          {
            label: 'Copywriting open L2 ',
            filter: 'copywriting_open_l2',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 18,
            decimal: false
          },
          {
            label: 'Spark first sync > 48',
            filter: 'spark_first_sync',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 1,
            decimals: false
          },
          {
            label: 'Spark re-sync > 48',
            filter: 'spark_re_sync',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 2,
            decimals: false
          },
          {
            label: 'Emails awaiting creation > 48',
            filter: 'emails_awaiting_creation',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 5,
            decimal: false
          },
          //ELIMINADO TEMPORALMENTE
          // {
          //   label: 'SMTP Auth failure > 48',
          //   filter: 'smtp_auth_failure',
          //   type: 'total',
          //   loading: false,
          //   valueTotal: null,
          //   value: null,
          //   task_type_id: 6,
          //   decimal: false
          // },
          {
            label: 'Domain config > 72',
            filter: 'domain_config',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 8,
            decimal: false,
          },
          {
            label: 'Domain Buy > 48',
            filter: 'domain_buy',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 12,
            decimal: false,
          },
          {
            label: 'Blocked Outlook emails > 48',
            filter: 'blocked_outlook_emails',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 3,
            decimal: false,
          },
          {
            label: 'Target Missing Data > 48',
            filter: 'target_missing_data',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 13,
            decimal: false,
          },
            {
            label: 'Smartlead warmup issues',
            filter: 'warmy',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 16,
            decimal: false,
          },
          //  {
          //   label: 'Commercial without email > 48',
          //   filter: 'commercial_without_email',
          //   type: 'average',
          //   loading: false,
          //   valueTotal: null,
          //   value: null,
          //   task_type_id: 17,
          //   decimal: false
          // },
          {
            label: 'Non prospecting emails > 48',
            filter: 'non_prospecting_emails',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 24,
            decimal: false,
          },
          {
            label: 'Client attribution > 48',
            filter: 'client_attribution',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 26,
            decimal: false,
          },
          {
            label: 'Phone lookup > 48',
            filter: 'phone_lookup',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 28,
            decimal: false,
          },
          {
            label: this.$t("lang.orders.orders") + ' missing email > 48',
            filter: 'orders_missing_email',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 29,
            decimal: false,
          },
          {
            label: 'Reported campaigns > 48',
            filter: 'reported_orders',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 31,
            decimal: false,
          },
          // {
          //   label: 'Unverified orders > 48',
          //   filter: 'unverified_orders',
          //   type: 'total',
          //   loading: false,
          //   valueTotal: null,
          //   value: null,
          //   task_type_id: 30,
          //   decimal: false,
          // },
          // {
          //   label: 'COM > 72',
          //   filter: 'com',
          //   type: 'total',
          //   loading: false,
          //   valueTotal: null,
          //   value: null,
          //   task_type_id: 21,
          //   decimal: false,
          // },
          {
            label: 'Critical Supply',
            filter: 'critical_supply',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 35,
            decimals: false
          },
          {
            label: 'Import errors',
            filter: 'import_errors',
            type: 'total',
            loading: false,
            valueTotal: null,
            value: null,
            task_type_id: 36,
            decimals: false
          },
          // {
          //   label: 'HOM > 72',
          //   filter: 'hom',
          //   type: 'total',
          //   loading: false,
          //   valueTotal: null,
          //   value: null,
          //   task_type_id: 32,
          //   decimal: false,
          // },

          ]
        },




        //Result
        {
          id: 'result',
          label: 'Result',
          column: 1,
          isLoading: true,
          detail: [
            {
              label: 'Meetings',
              filter: 'meetings',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              currentMonth: true,
              useStatmetrics: true,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Complaints',
              filter: 'complaints',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              currentMonth: true,
              useStatmetrics: true,
              decimals: false,
              variation: 'ok'
            },
            {
              label: 'Conversion rate',
              filter: 'conversion_rate',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: 3,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'Automatic Answers Rate',
              filter: 'er_automatic',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: "MAR (Manual Answer Rate)",
              filter: 'response_rate',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'Credits (current month)',
              filter: 'credits',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              currentMonth: true,
              useStatmetrics: true,
              variation: 'ok'
            },
            {
              label: 'CA (Hors-Taxe)',
              filter: 'money_without_tax',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '€',
              currentMonth: true,
              useStatmetrics: true,
              decimals: 2,
              variation: 'ok'
            },
            {
              label: 'Absent Rate',
              filter: 'absent_rate',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              currentMonth: true,
              useStatmetrics: true,
              variation: 'ok'
            },
            {
              label: 'AVG meeting price',
              filter: 'money_meetings_without_tax',
              type: 'average',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '€',
              currentMonth: true,
              useStatmetrics: true,
              decimals: 2,
              variation: 'ok'
            },

          ]
        },

        //BDR
        {
          id: 'bdr',
          label: 'Bookers',
          column: 3,
          isLoading: true,
          detail: [
            {
              label: 'Active bookers',
              filter: 'active_bookers',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation: 'ok'
            },
            // {
            //   label: 'Booker < 50 cold tasks',
            //   filter: 'booker_50_tasks',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   decimals: false
            // },
            // {
            //   label: 'Manager missing (level 2)',
            //   filter: 'booker_level_2_without_bm_assigned',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   decimals: false
            // },

            {
              label: 'Pick Up',
              filter: 'pick_ups',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'Accomplishment rate',
              filter: 'completion',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'Meeting rate (Level 2 & Managers)',
              filter: 'meeting_rate',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'Cold Meeting rate (Level 2 & Managers)',
              filter: 'cold_meeting_rate',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            // {
            //   label: 'Level 2 Cold Meeting rate',
            //   filter: 'level_2_cold_meeting_rate',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   variation: 'ok'
            // },
            // {
            //   label: 'Level 1 Cold Meeting rate',
            //   filter: 'level_1_cold_meeting_rate',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   variation: 'ok'
            // },
            {
              label: 'Consistency (Level 2 & Managers)',
              filter: 'consistency',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'Lost meetings rate (Level 2 & Managers)',
              filter: 'lost_meetings_prc',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              symbol: '%',
              variation: 'ok'
            },
            // {
            //   label: 'Performance warnings (Level 2 & Managers)',
            //   filter: 'performace_warnings',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   variation: 'ok'
            // },
            // {
            //   label: 'Consistency warnings (Level 2 & Managers)',
            //   filter: 'consistency_warnings',
            //   type: 'total',
            //   loading: false,
            //   valueTotal: null,
            //   value: null,
            //   variation: 'ok'
            // },
            {
              label: 'Meetings Booked',
              filter: 'meetings_booked',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              variation: 'ok'
            },
            {
              label: 'Booker impact',
              filter: 'booker_impact',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              symbol: '%',
              variation: 'ok'
            },
            {
              label: 'New Bookers',
              filter: 'new_bookers',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false
            },
            {
              label: 'banking info missing (Total)',
              filter: 'banking_info_missing',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation:'ok',
              statusKey: 'total'
            },
            {
              label: 'banking info missing (BKL2)',
              filter: 'banking_info_missing',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation:'ok',
              statusKey: 'Booker Level 2'
            },
            {
              label: 'banking info missing (BKL1)',
              filter: 'banking_info_missing',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation:'ok',
              statusKey: 'Booker Level 1'
            },
            {
              label: 'banking info missing (BKL3)',
              filter: 'banking_info_missing',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation:'ok',
              statusKey: 'Level 3'
            },
            {
              label: 'banking info missing (BKFR)',
              filter: 'banking_info_missing',
              type: 'total',
              loading: false,
              valueTotal: null,
              value: null,
              decimals: false,
              variation:'ok',
              statusKey: 'Booker France'
            }
          ]
        },

      ],
    };
  },
  mounted(){
    this.startProcessing(); // Llamar automáticamente al montar el componente (opcional)
  },
  beforeDestroy() {
    this.destroyProcess = true
  },
  created() {
    //this.getData();
  },
  methods: {
    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),
    // Mobile carousel methods
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
    },
    handleTouchMove(e) {
      this.touchEndX = e.changedTouches[0].screenX;
    },
    handleTouchEnd() {
      const swipeDistance = this.touchStartX - this.touchEndX;

      if (Math.abs(swipeDistance) > this.minSwipeDistance) {
        if (swipeDistance > 0) {
          // Swipe left - next slide
          this.nextSlide();
        } else {
          // Swipe right - previous slide
          this.prevSlide();
        }
      }

      // Reset values
      this.touchStartX = 0;
      this.touchEndX = 0;
    },
    goToSlide(index) {
      if (index >= 0 && index < this.data.length) {
        this.currentSlide = index;
      }
    },
    nextSlide() {
      if (this.currentSlide < this.data.length - 1) {
        this.currentSlide++;
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },
    processItems(items) {
      if (this.destroyProcess) {
        return;
      }

      if (items.length === 0) {
        this.startProcessing();
        return
      }

      const [currentItem, ...remainingItems] = items; // Extraer el primer elemento y el resto
      this.getDataCustom(currentItem); // Procesar el elemento actual

      // Determinar si se usa el intervalo corto o largo
      const nextInterval = (currentItem == 'bdr') ? this.longInterval : this.shortInterval;

      // Llamar al siguiente elemento después de 40 segundos
      setTimeout(() => {

        this.processItems(remainingItems);
      }, nextInterval);
    },
    startProcessing() {
      const mainOptions = this.data.map(item => item.id);

      //const mainOptions = this.data.filter( e => e.id == 'accountManagement').map(item => item.id);
      //const mainOptions = this.data.filter( e => e.id == 'result' || e.id == 'bookerRecruitment').map(item => item.id);
      //const mainOptions = this.data.filter( e => e.id == 'result').map(item => item.id);
      this.processItems(mainOptions); // Iniciar el procesamiento
    },
    getDataCustom(value) {
      const section = this.data.find(el => el.id === value);
      if (section) section.isLoading = true;
      //Inicializo todos los valores de este tipo (por ej. Financial) a null
      this.data.find( el => el.id == value)
        .detail.forEach(e => {

            e.valueTotal = null
            e.loading = false

            if(e.values){
              e.values = []
            }

            if(e.value){
              e.value = null
            }
        })
      const filter = this.data
                      .find( item => item.id == value).detail
                        .filter( e => e.filter)
                          .map( el => el.filter)

      this.getData(filter, value);
    },

    isUseMetrics(option, id) {

      const item = this.data.find( el => el.id == option).detail.find( e => e.filter == id)

      const useStatmetrics = item.useStatmetrics ? item.useStatmetrics : false

      return useStatmetrics
    },
    getData(dataFilter, id) {

      this.completeLoading = true

      if (dataFilter.length > 0) {

        // El primer filtro lo ejecuta al instannte.
        if(id === 'bdr'){
          this.getDataBdr(dataFilter[0], id);
          this.getDataBookerRecruitment(dataFilter[0], id);
        } else if (id === 'accountManagement') {
          if(dataFilter[0] == 'com'){
            this.getComMetrics(dataFilter[0], id);
          }else{
            this.getStatsAccountManagement(dataFilter[0], id);
          }
        } else {
          if(   id == 'result'|| id == 'sendings'|| id == 'financial'|| (id == 'operations' && dataFilter[0] ) || id == 'crons') {
            const isUseMetrics = this.isUseMetrics(id, dataFilter[0]);

            if(isUseMetrics){
              this.getUseMetrics(dataFilter[0], id );
            } else {

              if( (id == 'financial' && dataFilter[0] == 'cancel_rate')
                || (id == 'sendings'&& dataFilter[0] == 'sent')
                || (id == 'operations'&& dataFilter[0] == 'manual_tagged_er')
              ){

                this.getOnlyTotals(dataFilter[0], id, true)

              } else if(id == 'operations' && dataFilter[0] == 'zapmail_wallet_balance') {
                this.getDataUserZapmailDetails();

              } else {
                this.getStats(dataFilter[0], id);
              }

            }
          }
        }


        let index = (id != 'operations' || id != 'financial') ? 1 : 0;


        //Para los siguientes filtros, espera por cada uno 2 segundos.
        const intervalId = setInterval(() => {
          const el = dataFilter[index];

          if (el) {
             //Si el tipo de data a traer es para BDR
            if(id === 'bdr'){
              this.getDataBdr(el, id);
              this.getDataBookerRecruitment(el, id);
            } else if (id === 'accountManagement') {
              if(el == 'com'){
                this.getComMetrics(el, id);
              } else {
                const isUseMetrics = this.isUseMetrics(id, el);
                if(isUseMetrics){
                  this.getUseMetrics(el, id);
                } else {
                  this.getStatsAccountManagement(el, id);
                }
              }
            } else {

              const isUseMetrics = this.isUseMetrics(id, el);

              if(isUseMetrics){

                this.getUseMetrics(el, id );

              } else {

              //para un grupo de opciones de operatinos llame a otro endpoint para traer los datos
              const options = [
                  'blocked_outlook_emails',
                  'smtp_auth_failure',
                  'critical_supply',
                  'import_errors',
                  'emails_awaiting_creation',
                  'emails_not_tagged',
                  'copywriting_open_l1',
                  'copywriting_open_l2',
                  'spark_first_sync',
                  'spark_re_sync',
                  'non_prospecting_emails',
                  'domain_config',
                  'domain_buy',
                  'target_missing_data',
                  'warmy',
                  // 'commercial_without_email',
                  'client_attribution',
                  'burned_domains',
                  'phone_lookup',
                  'orders_missing_email',
                  'reported_orders',
                  //'unverified_orders',
                  'pay_declined_prctg',
                  'money_meetings',
                  //'money_meetings_without_tax',
                  'money_without_tax',
                  'absent_rate',
                  'critical_contact_issues',
                  'new_prospects_objective',
                  'bounce_prc',
                  'fullEnrichCredits',
                  'avg_waiting_to_be_enriched_contact',
                  'acc_avg',
                  'avg_contact_age',
                  'avg_contact_age_s1',
                  //'meetings',
                  'lcm',
                  'com',
                  'wac',
                 // 'hom',
                  'deliverability_tests',
                  'zapmail_wallet_balance',
                  //'mailboxes_unassigned_google',
                  'mailboxes_unassigned_microsoft',
                  'mailinblack_done',
                  'manual_tagged_er',
                  'cancel_rate',
                  ]

              if( (id == "deliverability" && options.includes(el)) ||
                  (id == "result" && options.includes(el)) ||
                  (id == "operations" && options.includes(el)) ||
                  (id == 'sendings' && options.includes(el)) ||
                   id == 'account_management' || (id == "financial" && options.includes(el) )) {

                const item = this.data.find( el => el.id == id).detail.find( e => e.filter == el)

                const fromStats = (
                      (id == 'financial' && !item.useStatmetrics) ||
                      (id == 'sendings' && item.useStatmetrics) ||
                      (id == 'result' && item.useStatmetrics)  ||
                      (id == 'operations' && item.useStats)  ||
                      (id == 'deliverability' && item.useStatmetrics)
                    ) ? true : false

                 if(el == 'zapmail_wallet_balance') {
                  this.getDataUserZapmailDetails();
                 } else if(el == 'mailboxes_unassigned_google' || el == 'mailboxes_unassigned_microsoft') {
                  // Data already fetched with zapmail_wallet_balance
                 } else if(el == 'fullEnrichCredits') {
                  this.getDataContactSearch(el, id);
                 } else if(el == 'import_errors') {
                  this.getDataImportErrors(el, id);
                 } else {
                  this.getOnlyTotals(el, id, fromStats);
                 }

              } else {
                this.getStats(el, id);
              }

              //this.getStats(el, id);

              }
            }

            index++;
          } else {
            clearInterval(intervalId)
            const section = this.data.find(el => el.id === id);
            if (section) section.isLoading = false;
          }
        }, 2000);
      }
    },

    getOnlyTotals(item, option, fromStats = false){

      if(fromStats){

        const currentMonth = this.data.find( el => el.id == option).detail.find( e => e.filter == item).currentMonth

        let startDate = this.startDate
        let endDate = this.endDate

        if(currentMonth){
          // con moment.js configuro primer y utlimo dia del mes para startdate y enddate
          // obtengo la fecha del primer dia del mes actdual y lo guardo en startDate
          startDate = moment().startOf('month').format('YYYY-MM-DD');
          endDate = moment().format('YYYY-MM-DD');

        }

        const args = {
            id: 0,
            startDate: startDate, //this.startDate,
            endDate: endDate,
            client: this.clientId, //2797, // false,
            filters: [item],
            last_days: false,
            non_admin: false,
            targetId: false
        }

        // this.data.find(e => e.id == option).detail
        //           .find( el => el.filter == item).loading=true

        campaignsService
          .getStatsRange(args.id,args.startDate,args.endDate,args.client,args.filters,args.last_days, args.non_admin, args.targetId)
            .then( res => {
              const resultItem = (res.activity_by_date && res.activity_by_date[item] ) ? res.activity_by_date[item][0] : false

              if(resultItem && (Number(resultItem) > 0 ) ){
                const formattedResult = parseFloat(Number(resultItem).toFixed(2));

                this.data.find( el => el.id == option).detail.find( e => e.filter == item).valueTotal = formattedResult

              } else {
                this.data.find( el => el.id == option).detail.find( e => e.filter == item).valueTotal = 'noData'
              }

        })
      } else {


        const itemFound = this.data.find( el => el.id == option).detail.find( e => e.filter == item)
        let task_type_id = 0

        if(itemFound.task_type_id){
          task_type_id = itemFound.task_type_id
        }

        let start_date, end_date = 0


        if(itemFound.useDates){
          start_date =  this.startDate
          end_date =  this.endDate
        }

        let status = 0
        if(item == 'copywriting_open_l1') {
          status = 1
        }
        if(item == 'copywriting_open_l2') {
          status = 2
        }

        usersService
          .getStatsMetrics(item, task_type_id, start_date, end_date, status)
            .then( data => {

              let metricItem = this.data.find( el => el.id == option).detail.find( e => e.filter == item)

              if(metricItem.values){
                let result = data.result

                if(item == 'deliverability_tests'){
                  result = this.formatdeliverabilityTests(result)
                }
                metricItem.values = result
              } else {
                metricItem.valueTotal = (data.result.total && metricItem.decimals != false) ? Number(data.result.total).toFixed(2) : Number(data.result.total)
              }

            })
          .catch(err => console.log(err))
      }

    },

    formatdeliverabilityTests(data){
      return data.map( el => {

        let nameFormated = ""

        switch (el.name) {
          case 'ews_ews':
            nameFormated = "Outlook > Outlook"
            break;
          case 'ews_gmail':
            nameFormated = "Outlook > Google"
            break;
          case 'gmail_ews':
            nameFormated = "Google > Outlook"
            break;
          case 'gmail_gmail':
            nameFormated = "Google > Google"
            break;
          default:
            break;
        }

        return {
          name: nameFormated,
          total: el.total
        }
      })
    },

    getDataContactSearch(dataFilter, id) {
      if( dataFilter === 'fullEnrichCredits'){
          campaignsService.getCampaignActiveSearching()
          .then((res) => {
            this.updateItemValue(res.enrich_credits.balance, 'empty', 'sendings', 'fullEnrichCredits', true);
          });
      }
    },

    getDataImportErrors(dataFilter, id) {
      targetsService.getTargetImportError(true)
      .then(res => {
          // this.orderError = res
          // this.loading = false;
          this.updateItemValue(res.total, 'empty', 'operations', 'import_errors', true);
      })
    },

    getDataUserZapmailDetails() {
      workspaceService.getUserZapmailDetails()
        .then( data => {
          // Wallet balance (same for both providers)
          const walletBalance = data.GOOGLE.walletBalance;
          this.updateItemValue(walletBalance, 'empty', 'operations', 'zapmail_wallet_balance', true);

          // // Mailboxes unassigned Google
          // const googleUnassigned = data.GOOGLE.purchasedMailboxes - data.GOOGLE.assignedMailboxes;
          // this.updateItemValue(googleUnassigned, 'empty', 'operations', 'mailboxes_unassigned_google', true);
          // // Update label with activePlan
          // this.data.find(e => e.id == 'operations').detail
          //   .find(el => el.filter == 'mailboxes_unassigned_google').label = `Mailboxes unassigned Google (${data.GOOGLE.activePlan} Plan)`;

          // Mailboxes unassigned Microsoft
          const microsoftUnassigned = data.MICROSOFT.purchasedMailboxes - data.MICROSOFT.assignedMailboxes;
          this.updateItemValue(microsoftUnassigned, 'empty', 'operations', 'mailboxes_unassigned_microsoft', true);
          // Update label with activePlan
          this.data.find(e => e.id == 'operations').detail
            .find(el => el.filter == 'mailboxes_unassigned_microsoft').label = `Mailboxes unassigned Microsoft (${data.MICROSOFT.activePlan} Plan)`;
        });
    },

    getComMetrics(dataFilter, id) {
      usersService
          .getStatsMetrics(dataFilter, 21, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'accountManagement', 'com', true);
              const accountManagementData = this.data.find(e => e.id == 'accountManagement');
              if(accountManagementData && data.result.by_am) {
                const comOption = accountManagementData.detail.find(el => el.filter === 'com');
                if(comOption) {
                  comOption.values = data.result.by_am.map(am => ({
                    name: am.am_name,
                    total: am.total
                  }));
                }
              }
            })
          .catch(err => console.log(err))
    },


    getStatsAccountManagement(dataFilter, id) {
      if( dataFilter === 'signed_client_mailboxes_5d'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result, 'empty', 'accountManagement', 'signed_client_mailboxes_5d', true);
            })
          .catch(err => console.log(err))
      }
      if( dataFilter === 'signed_clients_not_lunched_45d'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result, 'empty', 'accountManagement', 'signed_clients_not_lunched_45d', true);
            })
          .catch(err => console.log(err))
      }
      if( dataFilter === 'cold_call_client_0_bookers'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result, 'empty', 'accountManagement', 'cold_call_client_0_bookers', true);
            })
          .catch(err => console.log(err))
      }
      if( dataFilter === 'non_prospecting_emails_30d'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'accountManagement', 'non_prospecting_emails_30d', true);
              const accountManagementData = this.data.find(e => e.id == 'accountManagement');
              if(accountManagementData && data.result.by_am) {
                const nonProspectingOption = accountManagementData.detail.find(el => el.filter === 'non_prospecting_emails_30d');
                if(nonProspectingOption) {
                  nonProspectingOption.values = data.result.by_am.map(am => ({
                    name: am.am_name,
                    total: am.total
                  }));
                }
              }
            })
          .catch(err => console.log(err))
      }
      if( dataFilter === 'subscribers_without_cold_tasks_done'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'accountManagement', 'subscribers_without_cold_tasks_done', true);
              const accountManagementData = this.data.find(e => e.id == 'accountManagement');
              if(accountManagementData && data.result.by_client) {
                const opt = accountManagementData.detail.find(el => el.filter === 'subscribers_without_cold_tasks_done');
                if(opt) {
                  opt.values = data.result.by_client.map(c => ({
                    name: c.name,
                    total: c.total
                  }));
                }
              }
            })
          .catch(err => console.log(err))
      }
      if( dataFilter === 'billed_without_running_order'
        || dataFilter === 'deferred_without_kickoff_date'
        || dataFilter === 'signed_15d_without_kickoff_date'
        || dataFilter === 'kickoff_overdue_without_invoice'
        || dataFilter === 'flips_next_7_days'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'accountManagement', dataFilter, true);
              const accountManagementData = this.data.find(e => e.id == 'accountManagement');
              if(accountManagementData && data.result.by_client) {
                const opt = accountManagementData.detail.find(el => el.filter === dataFilter);
                if(opt) {
                  opt.values = data.result.by_client.map(c => ({
                    name: c.flip_date ? `${c.name} → ${c.flip_date}` : c.name,
                    total: c.total != null ? c.total : 1
                  }));
                }
              }
            })
          .catch(err => console.log(err))
      }
    },


    getUseMetrics(dataFilter, id) {
      if( dataFilter === 'cancel_rate'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, data.result.variation, 'result', 'cancel_rate', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'sent'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'sendings', 'sent', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'purchased_domains'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'accountManagement', 'purchased_domains', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'purchased_mailboxes'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'accountManagement', 'purchased_mailboxes', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'meetings'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'result', 'meetings', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'complaints'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'result', 'complaints', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'newprospects_first_prctg'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'sendings', 'newprospects_first_prctg', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'bounce_prc'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'sendings', 'bounce_prc', true);
            })
          .catch(err => console.log(err))
      }



      if( dataFilter === 'absent_rate'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, data.result.variation, 'result', 'absent_rate', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'money_without_tax'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'result', 'money_without_tax', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'money_meetings_without_tax'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'result', 'money_meetings_without_tax', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'credits'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.variation, data.result.total, 'result', 'credits', true);
            })
          .catch(err => console.log(err))
      }


      if( dataFilter === 'ringover-get-call-info') {
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              const dateRingoverGetCallInfo = data.result.totals.find(el => el.cron_name == 'ringover-get-call-info')
              const dateRingoverGetTranscription = data.result.totals.find(el => el.cron_name == 'ringover-get-transcription')
              const dateGetBookerScore = data.result.totals.find(el => el.cron_name == 'get-booker-score')
              const dateGetBookerInteractions = data.result.totals.find(el => el.cron_name == 'get-booker-Interactions')
              const dateCheckTranscription = data.result.totals.find(el => el.cron_name == 'check-transcription')
              const dateBdrGenerateScriptV2 = data.result.totals.find(el => el.cron_name == 'bdr-generate-script-v2')
              const accountCreated = data.result.totals.find(el => el.cron_name == 'account-created')
              const dateStatusRejected = data.result.totals.find(el => el.cron_name == 'status-rejected')
              const dateStatusOnboarding = data.result.totals.find(el => el.cron_name == 'status-onboarding')
              const dateScreening3day = data.result.totals.find(el => el.cron_name == 'screening-3day')
              const dateStatusStopped = data.result.totals.find(el => el.cron_name == 'status-stopped')
              const dateStatusStandby = data.result.totals.find(el => el.cron_name == 'status-standby')
              const datePerformanceAlert1 = data.result.totals.find(el => el.cron_name == 'performance-alert-1')
              const datePerformanceAlert2 = data.result.totals.find(el => el.cron_name == 'performance-alert-2')
              const dateConsistencyAlert1 = data.result.totals.find(el => el.cron_name == 'consistency-alert-1')
              const dateLostMeetingAlert = data.result.totals.find(el => el.cron_name == 'lost-meeting-alert')
              const datePickupAlert = data.result.totals.find(el => el.cron_name == 'pickup-alert')

              this.updateItemValue((dateRingoverGetCallInfo) ? dateRingoverGetCallInfo.last_date : 'No data', 'empty', 'crons', 'ringover-get-call-info', null, true);
              this.updateItemValue((dateRingoverGetTranscription) ? dateRingoverGetTranscription.last_date : 'No data', 'empty', 'crons', 'ringover-get-transcription', null, true);
              this.updateItemValue((dateGetBookerScore) ? dateGetBookerScore.last_date : 'No data', 'empty', 'crons', 'get-booker-score', null, true);
              this.updateItemValue((dateGetBookerInteractions) ? dateGetBookerInteractions.last_date : 'No data', 'empty', 'crons', 'get-booker-Interactions', null, true);
              this.updateItemValue((dateCheckTranscription) ? dateCheckTranscription.last_date : 'No data', 'empty', 'crons', 'check-transcription', null, true);
              this.updateItemValue((dateBdrGenerateScriptV2) ? dateBdrGenerateScriptV2.last_date : 'No data', 'empty', 'crons', 'bdr-generate-script-v2', null, true);
              this.updateItemValue((accountCreated) ? accountCreated.last_date : 'No data', 'empty', 'crons', 'account-created', null, true);
              this.updateItemValue((dateStatusRejected) ? dateStatusRejected.last_date : 'No data', 'empty', 'crons', 'status-rejected', null, true);
              this.updateItemValue((dateStatusOnboarding) ? dateStatusOnboarding.last_date : 'No data', 'empty', 'crons', 'status-onboarding', null, true);
              this.updateItemValue((dateScreening3day) ? dateScreening3day.last_date : 'No data', 'empty', 'crons', 'screening-3day', null, true);
              this.updateItemValue((dateStatusStopped) ? dateStatusStopped.last_date : 'No data', 'empty', 'crons', 'status-stopped', null, true);
              this.updateItemValue((dateStatusStandby) ? dateStatusStandby.last_date : 'No data', 'empty', 'crons', 'status-standby', null, true);
              this.updateItemValue((datePerformanceAlert1) ? datePerformanceAlert1.last_date : 'No data', 'empty', 'crons', 'performance-alert-1', null, true);
              this.updateItemValue((datePerformanceAlert2) ? datePerformanceAlert2.last_date : 'No data', 'empty', 'crons', 'performance-alert-2', null, true);
              this.updateItemValue((dateConsistencyAlert1) ? dateConsistencyAlert1.last_date : 'No data', 'empty', 'crons', 'consistency-alert-1', null, true);
              this.updateItemValue((dateLostMeetingAlert) ? dateLostMeetingAlert.last_date : 'No data', 'empty', 'crons', 'lost-meeting-alert', null, true);
              this.updateItemValue((datePickupAlert) ? datePickupAlert.last_date : 'No data', 'empty', 'crons', 'pickup-alert', null, true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'total-absent-meeting-treatment'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.last_date || 'No data', 'empty', 'crons', 'absent-meeting-treatment', null, true);
              this.updateItemValue(data.result.total, 'empty', 'crons', 'total-absent-meeting-treatment', true);
            })
          .catch(err => console.log(err))
      }


    },

    getDataBookerRecruitment(dataFilter, id) {
      if( dataFilter === 'bookers_screening'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              const bookers_screening = data.result.totals.find(el => el.user_bdr_status_id == '1').total
              const bookers_onboarding = data.result.totals.find(el => el.user_bdr_status_id == '2').total
              this.updateItemValue(bookers_screening, 'empty', 'bookerRecruitment', 'bookers_screening', true);
              this.updateItemValue(bookers_onboarding, 'empty', 'bookerRecruitment', 'bookers_onboarding', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'bookers_essai_0_tasks'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bookerRecruitment', 'bookers_essai_0_tasks', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'bookers_standby_no_starting_date'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bookerRecruitment', 'bookers_standby_no_starting_date', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'bookers_standby_late'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bookerRecruitment', 'bookers_standby_late', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'new_bookers'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bdr', 'new_bookers', true);
            })
          .catch(err => console.log(err))
      }

      if( dataFilter === 'banking_info_missing'){
        usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              // Actualizar todas las columnas de banking_info_missing con sus valores correspondientes
              const bdrData = this.data.find(e => e.id == 'bdr');
              if(bdrData) {
                bdrData.detail.forEach(column => {
                  if(column.filter === 'banking_info_missing' && column.statusKey) {
                    let value = null;

                    if(column.statusKey === 'total') {
                      value = data.result.total;
                    } else if(data.result.by_status && data.result.by_status[column.statusKey]) {
                      value = parseInt(data.result.by_status[column.statusKey]) || 0;
                    } else {
                      value = 0;
                    }

                    // Actualizar directamente la columna específica usando statusKey
                    const targetColumn = bdrData.detail.find(el =>
                      el.filter === 'banking_info_missing' && el.statusKey === column.statusKey
                    );

                    if(targetColumn) {
                      targetColumn.valueTotal = value;
                      // Actualizar variation según la lógica existente
                      targetColumn.variation = (value > 0) ? 'danger' : 'down';
                    }
                  }
                });
              }
            })
          .catch(err => console.log(err))
      }

    },

    calculateWarningToBookers(data){
      let totalPerformaceWarnings = 0
      let totalConsistencyWarnings = 0

      if (data.result.length > 0) {
      const result = data.result;

      result.forEach((element) => {
          element.min_r1 = 5;
          element.max_r1 = 50;

          if (element.consistency < 60) {
            element.salary_degrasivity = this.$t(
              "lang.bdr.salarydegrasivity50prc"
            );
          } else if (element.consistency < 80) {
            element.salary_degrasivity = this.$t(
              "lang.bdr.salarydegrasivity70prc"
            );
          }

          if (element.adapted_fixed_salary) {
            element.fixed_salary_tooltip = this.$t("lang.bdr.fixed_salary");
          } else {
            element.fixed_salary_tooltip = "";
          }

          if (["5", "6"].includes(element.user_bdr_status_id)) {
            if (
              element.verified_tasks >= 300 &&
              element.verified_tasks < 600 &&
              element.cold_meeting_rate == 0
            ) {
              element.warning_icon = 1;
            } else if (
              element.verified_tasks >= 600 &&
              element.cold_meeting_rate == 0
            ) {
              totalPerformaceWarnings++
            }
            const today = new Date();
            const todayDay = today.getDate();
            if (
              element.consistency < 15 &&
              element.cold_meeting_rate == 0
            ) {
              if (
                (element.user_bdr_status_id == 4 &&
                  element.days_since_status_change >= 5 &&
                  element.days_since_status_change < 15) ||
                ((element.days_since_status_change >= 30 || element.user_bdr_status_id == 5)
                  && todayDay >= 5 &&
                  todayDay < 15)
              ) {
                element.warning_icon = 3;
              } else if (
                (element.user_bdr_status_id == 4 &&
                  element.days_since_status_change >= 15 &&
                  element.days_since_status_change < 30) ||
                ((element.days_since_status_change >= 30 || element.user_bdr_status_id == 5)
                  && todayDay >= 15)
              ) {
                totalConsistencyWarnings++
              }
            }
          }
        });



        return {
          totalPerformaceWarnings,
          totalConsistencyWarnings,
        }
      }


    },

    calculateDataToBookers(data){
      if (data.result.length > 0) {
      const result = data.result;

      result.forEach((element) => {
          element.min_r1 = 5;
          element.max_r1 = 50;

          if (element.consistency < 60) {
            element.salary_degrasivity = this.$t(
              "lang.bdr.salarydegrasivity50prc"
            );
          } else if (element.consistency < 80) {
            element.salary_degrasivity = this.$t(
              "lang.bdr.salarydegrasivity70prc"
            );
          }

          if (element.adapted_fixed_salary) {
            element.fixed_salary_tooltip = this.$t("lang.bdr.fixed_salary");
          } else {
            element.fixed_salary_tooltip = "";
          }

          // if (["4", "5"].includes(element.user_bdr_status_id)) {
          //   if (
          //     element.verified_tasks >= 300 &&
          //     element.verified_tasks < 600 &&
          //     element.cold_meeting_rate == 0
          //   ) {
          //     element.warning_icon = 1;
          //   } else if (
          //     element.verified_tasks >= 600 &&
          //     element.cold_meeting_rate == 0
          //   ) {
          //     totalPerformaceWarnings++
          //   }
          //   const today = new Date();
          //   const todayDay = today.getDate();
          //   if (
          //     element.consistency < 15 &&
          //     element.cold_meeting_rate == 0
          //   ) {
          //     if (
          //       (element.user_bdr_status_id == 4 &&
          //         element.days_since_status_change >= 5 &&
          //         element.days_since_status_change < 15) ||
          //       ((element.days_since_status_change >= 30 || element.user_bdr_status_id == 5)
          //         && todayDay >= 5 &&
          //         todayDay < 15)
          //     ) {
          //       element.warning_icon = 3;
          //     } else if (
          //       (element.user_bdr_status_id == 4 &&
          //         element.days_since_status_change >= 15 &&
          //         element.days_since_status_change < 30) ||
          //       ((element.days_since_status_change >= 30 || element.user_bdr_status_id == 5)
          //         && todayDay >= 15)
          //     ) {
          //       totalConsistencyWarnings++
          //     }
          //   }
          // }
        });

        const meetings_booked_total = result.reduce(
          (sum, item) => sum + Number(item.meetings_booked),
          0
        );

        const simple_pick_ups_rate =
        result
            .filter((el) => el.pick_ups)
            .reduce((sum, item) => sum + Number(item.pick_ups), 0) /
          result.filter((el) => el.pick_ups).length;

        const simple_meeting_rate =
          result
            .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
            .filter((el) => el.meetings_rate)
            .reduce((sum, item) => sum + Number(item.meetings_rate), 0) /
          result
            .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
            .filter((el) => el.meetings_rate).length;


        const simple_completion_rate =
          result
            .filter((el) => el.completion)
            .reduce(
              (sum, item) => sum + Number(item.completion),
              0
            ) / result.filter((el) => el.completion).length;

            const simple_cold_meeting_rate =
          result
            .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
            .filter((el) => el.cold_meeting_rate)
            .reduce(
              (sum, item) => sum + Number(item.cold_meeting_rate),
              0
            ) / result
                .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
                .filter((el) => el.cold_meeting_rate).length;

          const simple_cold_meeting_rate_level1 =
          result
            .filter((el) => el.cold_meeting_rate  && el.user_bdr_status_id == '4')
            .reduce(
              (sum, item) => sum + Number(item.cold_meeting_rate),
              0
            ) / result.filter((el) => el.cold_meeting_rate).length;

          const simple_cold_meeting_rate_level2 =
          result
            .filter((el) => el.cold_meeting_rate  && el.user_bdr_status_id == '5')
            .reduce(
              (sum, item) => sum + Number(item.cold_meeting_rate),
              0
            ) / result.filter((el) => el.cold_meeting_rate).length;


        const booker_salary_total = result.reduce(
          (sum, item) => sum + Number(item.booker_salary),
          0
        );
        const booker_revenue_generated_total = result.reduce(
          (sum, item) => sum + Number(item.booker_revenue_generated),
          0
        );
        const simple_booker_gross_margin =
          ((booker_revenue_generated_total - booker_salary_total) /
            booker_revenue_generated_total) *
          100;

        const simple_consistency =
          result
            .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
            .filter((el) => el.consistency)
            .reduce((sum, item) => sum + Number(item.consistency), 0) /
          result
          .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
          .filter((el) => el.consistency).length;

        const fixed_salary_total = result.reduce(
          (sum, item) => sum + Number(item.adapted_fixed_salary),
          0
        );

        // const filtered = result.map(el => ({
        //       ...el,
        //       lost_meetings_prc: el.lost_meetings_prc != null ? Number(el.lost_meetings_prc) : 0
        //     }));

        // const count = filtered.length;
        const count = result.filter((el) => el.lost_meetings_prc).length

        const total_meetings_lost_rate = count > 0
          ?  result
            .filter(e => e.user_bdr_status_id == '5' || e.user_bdr_status_id == '6')
            .filter((el) => el.consistency)
            .reduce((sum, item) => sum + Number(item.lost_meetings_prc), 0) / result.filter((el) => el.lost_meetings_prc).length
          : 0;

        return {
          // totalPerformaceWarnings,
          // totalConsistencyWarnings,
          simple_meeting_rate,
          simple_consistency,
          simple_cold_meeting_rate,
          simple_cold_meeting_rate_level1,
          simple_cold_meeting_rate_level2,
          meetings_booked_total,
          simple_pick_ups_rate,
          total_meetings_lost_rate,
          simple_completion_rate,
        }
      }


    },

    getDataBdr(dataFilter, id) {
      // Crea dos objetos de fecha usando Moment.js
      const startDate = moment(this.startDate, 'YYYY-MM-DD');
      const endDate = moment(this.endDate, 'YYYY-MM-DD')

      const differenceInDays = endDate.diff(startDate, 'days');

      if( dataFilter === 'meeting_rate'){
          //const filters = {start_date:this.startDate, end_date:this.endDate, to_stats: 1, metric_type: 'meeting_rate'}
          const filters = {start_date:this.startDate, end_date:this.endDate}
          bookersService
          .getBookerRanking(filters)
          .then((response) => {

            const data =this.calculateDataToBookers(response)

            let start = moment(this.startDate);
            let end = moment(this.endDate);

            // Si es lunes -> restar 3 días (viernes anterior)
            // En caso contrario -> restar 1 día
            if (start.day() === 1) {
              start = start.subtract(3, 'days');
              end = end.subtract(3, 'days');
            } else {
              start = start.subtract(1, 'days');
              end = end.subtract(1, 'days');
            }

            this.startDate = start.format('YYYY-MM-DD');
            this.endDate = end.format('YYYY-MM-DD');

            const filters = {
              start_date: this.startDate,  //moment(this.startDate).subtract(1, 'day').format('YYYY-MM-DD'),
              end_date: this.endDate // moment(this.endDate).subtract(1, 'day').format('YYYY-MM-DD')
            };
            bookersService
              .getBookerRanking(filters)
              .then((response) => {

                const variation =this.calculateDataToBookers(response)

                this.updateItemValue(variation.simple_meeting_rate, data.simple_meeting_rate,'bdr', 'meeting_rate', true);
                this.updateItemValue(data.simple_consistency,variation.simple_consistency, 'bdr', 'consistency', true);
                this.updateItemValue(variation.simple_cold_meeting_rate , data.simple_cold_meeting_rate, 'bdr', 'cold_meeting_rate', true);
                // this.updateItemValue(variation.meetings_booked_total , data.meetings_booked_total, 'bdr', 'meetings_booked', true);
                this.updateItemValue(variation.simple_pick_ups_rate , data.simple_pick_ups_rate, 'bdr', 'pick_ups', true);
                this.updateItemValue(variation.total_meetings_lost_rate , data.total_meetings_lost_rate, 'bdr', 'lost_meetings_prc', true);
                this.updateItemValue(variation.simple_completion_rate , data.simple_completion_rate, 'bdr', 'completion', true);
                // this.updateItemValue(variation.totalPerformaceWarnings , data.totalPerformaceWarnings, 'bdr', 'performace_warnings', true);
                // this.updateItemValue(variation.totalConsistencyWarnings , data.totalConsistencyWarnings, 'bdr', 'consistency_warnings', true);


              })

          })
       }

       if( dataFilter === 'active_bookers'){
          usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bdr', 'active_bookers', true);
            })
          .catch(err => console.log(err))
        }

        if( dataFilter === 'booker_50_tasks'){
          usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bdr', 'booker_50_tasks', true);
            })
          .catch(err => console.log(err))
        }

        if( dataFilter === 'meetings_booked'){
          usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bdr', 'meetings_booked', true);
            })
          .catch(err => console.log(err))
        }

        if( dataFilter === 'booker_level_2_without_bm_assigned'){
          usersService
          .getStatsMetrics(dataFilter, 0, this.startDate, this.endDate)
            .then( data => {
              this.updateItemValue(data.result.total, 'empty', 'bdr', 'booker_level_2_without_bm_assigned', true);
            })
          .catch(err => console.log(err))
        }


       if( dataFilter === 'booker_impact'){
        const filters = {start_date:this.startDate, end_date:this.endDate, to_stats: 1, metric_type: 'booker_impact'}
        bookersService
          .getBookerRanking(filters)
          .then((data) => {

            const filters = {
              start_date: moment(this.startDate).subtract(1, 'day').format('YYYY-MM-DD'),
              end_date: moment(this.endDate).subtract(1, 'day').format('YYYY-MM-DD'),
              to_stats: 1, metric_type: 'booker_impact'
            }

            bookersService
            .getBookerRanking(filters)
            .then((variation) => {
              this.updateItemValue(variation.result, data.result, 'bdr', 'booker_impact', true);
            })
          })
       }

       if( dataFilter === 'performace_warnings'){
        const monthFirstDay = moment().startOf('month').format('YYYY-MM-DD');
        const today = moment().format('YYYY-MM-DD');

        const filters = {start_date: monthFirstDay, end_date: today}
        bookersService
          .getBookerRanking(filters)
          .then((response) => {

            const data =this.calculateWarningToBookers(response)

            // const beforeMonthFistDay =  moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            // const beforeToday = moment().subtract(1, 'months').format('YYYY-MM-DD');

            // const filters = {
            //   start_date: beforeMonthFistDay,
            //   end_date: beforeToday,
            // }

            // bookersService
            // .getBookerRanking(filters)
            // .then((response) => {
            //   const variation =this.calculateWarningToBookers(response)

              this.updateItemValue(data.totalPerformaceWarnings, 'empty', 'bdr', 'performace_warnings', true);
              this.updateItemValue(data.totalConsistencyWarnings,'empty', 'bdr', 'consistency_warnings', true);
            //})
          })
       }
    },

    updateItemValue(firstValue, secondValue, id, idItem, isSingleValue = true, isValueDate = false){

      if(idItem == 'signed_client_mailboxes_5d' || idItem == 'signed_clients_not_lunched_45d' || idItem == 'cold_call_client_0_bookers'){

        let item = this.data.find(e => e.id == id).detail
              .find( el => el.filter == idItem)

        item.values = firstValue
        item.valueTotal = firstValue.reduce( (acc, el) => acc + parseInt(el.total),0)
        return false
      }

      if(isValueDate){

        this.data.find(e => e.id == id).detail
              .find( el => el.filter == idItem).value=firstValue

        return false
      }

        if(!isSingleValue){

          this.data.find(e => e.id == id).detail
                .find( el => el.filter == idItem).values=firstValue

          return false
        }

        if( ( firstValue != 'empty' && secondValue != 'empty')){


          let percentageChange = 0
          let isLess =  false

          if ( !(firstValue == 0.00 && secondValue == 0.00)){
              if (firstValue == 0.00) {
                  // Define el comportamiento cuando firstValue es 0
                  percentageChange = secondValue > 0 ? 100 : 0; // 100% si secondValue es positivo, 0% si es 0 o negativo
                  isLess = (secondValue > 0) ? false  : true
              } else {
                  percentageChange = ((firstValue - secondValue) / firstValue) * 100;

                  if (secondValue < firstValue  ) {
                    percentageChange = -percentageChange
                  } else {
                    percentageChange = Math.abs(percentageChange);
                  }
              }

              this.data.find(e => e.id == id).detail
                .find( el => el.filter == idItem).value=percentageChange.toFixed(2)


              const decimals = this.data.find(e => e.id == id).detail
                        .find( el => el.filter == idItem).decimals

              let configDecimals = 2

              if (decimals === false) {
                configDecimals = 0
              } else {
                configDecimals = (decimals) ? decimals : 2
              }

              secondValue = Number(secondValue).toFixed(configDecimals)

              this.data.find(e => e.id == id).detail
                .find( el => el.filter == idItem).valueTotal=secondValue


              const item = this.data.find(e => e.id == id).detail.find( el => el.filter == idItem)

              let variation = 'ok'

              if(item.variation){

                const customColorVariation1 = ['bounce_prc','er_automatic','cancel_rate','absent_rate','lost_meetings_prc']

                const customColorVariation2 = ['sent','newprospects_first_prctg','accounts_sent',
                  'email_sent_acc','meetings','conversion_rate','response_rate',
                  'money_without_tax', 'money_meetings_without_tax', 'pick_ups', 'completion',
                  'meeting_rate', 'cold_meeting_rate', 'consistency', 'complaints']

                if(customColorVariation2.includes(idItem)) {
                  variation = 'down'
                  //percentageChange = -28
                  if(percentageChange < -100) {
                    variation = 'danger'
                  } else {
                    if(percentageChange > 100 ) {
                      variation = 'ok'
                    }
                  }

                } else {
                  if(customColorVariation1.includes(idItem)) {
                    variation = 'down'
                    //percentageChange = -28
                    if(percentageChange < -100) {
                      variation = 'ok'
                    } else {
                      if(percentageChange > 100 ) {
                        variation = 'danger'
                      }
                    }

                  } else {
                    variation = 'down'

                    if(idItem == 'booker_impact') {
                      if(percentageChange < -100 || percentageChange > 100 ) {
                        variation = 'danger'
                      }

                    } else {
                      if(percentageChange < -100) {
                        variation = 'ok'
                      }

                      if(percentageChange > 100) {
                        variation = 'ok'
                      }

                    }
                  }

                }

                if(idItem == 'credits') {
                  variation = (item.valueTotal > 12 ) ? 'danger' : 'down'
                }

                // Mostrar en rojo si el porcentaje de variación es superior a 100% para purchased_domains y purchased_mailboxes
                if(idItem == 'purchased_domains' || idItem == 'purchased_mailboxes') {
                  variation = 'down'
                  if(percentageChange < -100) {
                    variation = 'danger'
                  } else if(percentageChange > 100) {
                    variation = 'danger' // Mostrar en rojo si pasa de 100%
                  }
                }

                this.data.find(e => e.id == id).detail
                .find( el => el.filter == idItem).variation=variation

                // if(idItem == 'cancel_rate') {
                //  console.log("data..", this.data.find(e => e.id == id).detail.find( el => el.filter == idItem))
                // }
              }

          } else {

            this.data.find(e => e.id == id).detail
                .find( el => el.filter == idItem).value='0'

              this.data.find(e => e.id == id).detail
                .find( el => el.filter == idItem).valueTotal='0'
          }

        } else {



          const decimals = this.data.find(e => e.id == id).detail
                        .find( el => el.filter == idItem).decimals

          let configDecimals = 2

          if (decimals === false) {
            configDecimals = 0
          } else {
            configDecimals = (decimals) ? decimals : 2
          }

          firstValue = Number(firstValue).toFixed(configDecimals)

          this.data.find(e => e.id == id).detail
          .find( el => el.filter == idItem).valueTotal=firstValue

          const item = this.data.find(e => e.id == id).detail.find( el => el.filter == idItem)

          let variationDefault = 'up'

          if(idItem == 'fullEnrichCredits' ) {
            variationDefault = (firstValue < 20000) ? 'danger' : 'down'
          }

          if(idItem == 'zapmail_wallet_balance' ) {
            variationDefault = (firstValue < 300 ) ? 'danger' : 'down'
          }

          if(idItem == 'mailboxes_unassigned_google' || idItem == 'mailboxes_unassigned_microsoft') {
            variationDefault = (firstValue > 0) ? 'danger' : 'down'
          }

          const upperZero = ['bookers_essai_0_tasks',
                            'bookers_standby_late',
                            'booker_50_tasks',
                            'booker_level_2_without_bm_assigned',
                            'performace_warnings', 'consistency_warnings']

          const equalZero = ['new_bookers','active_bookers', 'meetings_booked']


          if(idItem == 'mailinblack_done' && item.min) {
            variationDefault = (firstValue < item.min) ? 'down' : 'up'
          }

          if(idItem == 'bookers_screening' ||
            idItem == 'bookers_onboarding' ||
            idItem == 'bookers_standby_no_starting_date'
          )
            {
            variationDefault = (firstValue == 0) ? 'down' : 'danger'
          }

          if(equalZero.includes(idItem)){
            variationDefault = (firstValue == 0) ? 'danger' : 'down'
          }

          if(upperZero.includes(idItem)){
            variationDefault = (firstValue > 0) ? 'danger' : 'down'
          }

          if(idItem == 'consistency' ) {
            variationDefault = (firstValue == 0) ? 'danger' : 'down'
          }

          if(idItem == 'banking_info_missing' ) {
            variationDefault = (firstValue > 0) ? 'danger' : 'down'
          }

          // Mostrar en rojo si el valor es superior a 0 para non_prospecting_emails_30d y métricas billing kickoff
          if(idItem == 'non_prospecting_emails_30d' || idItem == 'subscribers_without_cold_tasks_done'
            || idItem == 'billed_without_running_order' || idItem == 'deferred_without_kickoff_date'
            || idItem == 'signed_15d_without_kickoff_date' || idItem == 'kickoff_overdue_without_invoice'
            || idItem == 'flips_next_7_days') {
            variationDefault = (firstValue > 0) ? 'danger' : 'ok'
          }

          this.data.find(e => e.id == id).detail.find( el => el.filter == idItem).variation=variationDefault

        }
        // this.data.find(e => e.id == id).detail
        //           .find( el => el.filter == idItem).loading=false
    },

    getStats(dataFilter, id){
      let firstValue, secondValue = null



      const item = this.data.find( el => el.id == id).detail.find( e => e.filter == dataFilter)

      //Si solo quierio el valor del dia anterior y sin tener en cuenta la variacion.
      if(item.yesterday) {

        const startDate = moment(this.startDate).subtract(1, "days").format("YYYY-MM-DD");
        const endDate = moment(this.endDate).subtract(1, "days").format("YYYY-MM-DD");

        const args = {
          id: 0,
          startDate: startDate,
          endDate: endDate,
          client: this.clientId,
          filters: [dataFilter],
          last_days: false,
          non_admin: false,
          targetId: false
      }

      // this.data.find(e => e.id == id).detail
      //           .find( el => el.filter == dataFilter).loading=true
        campaignsService
        .getStatsRange(args.id,args.startDate,args.endDate,args.client,args.filters,args.last_days, args.non_admin, args.targetId)
          .then( res => {

            const resultItem = Number(res.activity_by_date[dataFilter])

            this.updateItemValue(resultItem, 'empty', 'operations', 'mailinblack_done', true);

          })
        return
      }


      // Crea dos objetos de fecha usando Moment.js
      const startDate = moment(this.startDate, 'YYYY-MM-DD');
      const endDate = moment(this.endDate, 'YYYY-MM-DD');

      const differenceInDays = endDate.diff(startDate, 'days');

      let startDate2 = moment(this.startDate).subtract(differenceInDays + 1, "days").format("YYYY-MM-DD");
      let endtDate2 = moment(this.endDate).subtract(differenceInDays + 1, "days").format("YYYY-MM-DD");

      //Si el dia de startDate es lunes entonces la fecha anterior debe ser el viernes anterior
      if(moment(this.startDate).day() == 1){
        startDate2 = moment(this.startDate).subtract(3, 'days').format("YYYY-MM-DD");
        endtDate2 = moment(this.endDate).subtract(3, 'days').format("YYYY-MM-DD");
      }

      const args = {
          id: 0,
          startDate: this.startDate,
          endDate: this.endDate,
          client: this.clientId, //2797, // false,
          filters: [dataFilter],
          last_days: false,
          non_admin: false,
          targetId: false
      }

      this.data.find(e => e.id == id).detail
                .find( el => el.filter == dataFilter).loading=true

      campaignsService
        .getStatsRange(args.id,args.startDate,args.endDate,args.client,args.filters,args.last_days, args.non_admin, args.targetId)
          .then( res => {
            secondValue = 0
            let qtyValues = 0
            const resultItem = res.activity_by_date[dataFilter]

            if((resultItem && resultItem.length > 0) || (resultItem && resultItem[0] != '0.0000' )) {
                qtyValues = resultItem.length
                resultItem.forEach( el => {
                  const num = parseFloat(el);
                  if (typeof num === 'number' && !isNaN(num)) {
                    secondValue = secondValue + num
                  }
                })
            } else {
              secondValue = "empty"
            }

            // obtengo el dato si el tipo de datos que estoy trabajando es para total o average
            const typeTotal = this.data.find(e => e.id == id).detail
                .find( el => el.filter == dataFilter).type

            //sino es total entonces calculo el promedio de todos los valores encontrados.
            if(typeTotal != 'total' && secondValue != 'empty'){
              secondValue = secondValue / qtyValues
            }


            campaignsService
              .getStatsRange(args.id,startDate2,endtDate2,args.client,args.filters,args.last_days, args.non_admin, args.targetId)
                .then( result => {
                  firstValue = 0
                  let qtyValues = 0
                  const resultItem = result.activity_by_date[dataFilter]
                  // firstValue = resultItem.reduce((acc, val) => acc + (+val), 0);
                  if((resultItem && resultItem.length > 0) || (resultItem && resultItem[0] != '0.0000' )) {
                    qtyValues = resultItem.length
                    resultItem.forEach( el => {
                      const num = parseFloat(el);
                      if (typeof num === 'number' && !isNaN(num)) {
                        firstValue = firstValue + num
                      }
                    })

                  } else {
                    firstValue = 'empty';
                  }

                  // obtengo el dato si el tipo de datos que estoy trabajando es para total o average
                  const typeTotal = this.data.find(e => e.id == id).detail
                      .find( el => el.filter == dataFilter).type

                  //sino es total entocnes calculo el promedio de todos los valores encontrados.
                  if(typeTotal != 'total' && firstValue != 'empty'){
                    firstValue = firstValue / qtyValues
                  }

                  if( (firstValue != 'empty' && secondValue != 'empty')){
                    let percentageChange = 0
                    let valueTotal = 0


                    if ( !(firstValue == 0 && secondValue == 0)){
                        if(firstValue === 0){
                          percentageChange = secondValue * 100
                        } else {
                          percentageChange =  (secondValue / firstValue) * 100

                          if(secondValue < firstValue){
                            percentageChange = 100 - percentageChange
                            percentageChange = percentageChange * -1
                          } else {
                            percentageChange = percentageChange - 100
                          }
                        }
                        valueTotal = secondValue //firstValue + secondValue;

                        // // obtengo el dato si el tipo de datos que estoy trabajando es para total o average
                        // const typeTotal = this.data.find(e => e.id == id).detail
                        //     .find( el => el.filter == dataFilter).type

                        // //sino es total entonces calculo el promedio de todos los valores encontrados.
                        // // if(typeTotal != 'total'){
                        // //   valueTotal = valueTotal / 2
                        // // }



                        const item = this.data.find(e => e.id == id).detail.find( el => el.filter == dataFilter)


                        if(item.variation) {

                          const customColorVariation1 = ['bounce_prc','er_automatic','cancel_rate','absent_rate','lost_meetings_prc']

                          const customColorVariation2 = ['sent','newprospects_first_prctg','accounts_sent',
                            'email_sent_acc','meetings','conversion_rate','response_rate',
                            'money_without_tax', 'money_meetings_without_tax', 'pick_ups', 'completion',
                            'meeting_rate', 'cold_meeting_rate', 'consistency', 'credits']

                          // - Total email sent
                          // - New prospects first time (yesterday)
                          // - PEAs
                          // - Email sent / PEA
                          // - Meetings
                          // - Conversion rate
                          // - MAR (Manual Answer Rate)
                          // - CA (Hors-Taxe)
                          // - AVG meeting price
                          // - Pick Up
                          // - Accomplishment rate
                          // - Meeting rate (Level 2 & Managers)
                          // - Cold Meeting rate (Level 2 & Managers)
                          // - Consistency (Level 2 & Managers)

                          let variation = 'down'

                          if(customColorVariation2.includes(dataFilter)) {

                              if(percentageChange < -100) {
                                variation = 'danger'
                              } else {
                                if(percentageChange > 100 ) {
                                 variation = 'ok'
                                }
                              }


                          } else {

                            if(customColorVariation1.includes(dataFilter)) {

                              if(percentageChange < -100) {
                                variation = 'ok'
                              } else {
                                if(percentageChange > 100 ) {
                                 variation = 'danger'
                                }
                              }


                            } else {
                              if(percentageChange < -19) {
                                variation = 'ok'
                              }

                              if(percentageChange > 19) {
                                variation = 'ok'
                              }
                            }

                          }





                          this.data.find(e => e.id == id).detail
                          .find( el => el.filter == dataFilter).variation=variation

                        }

                    }

                     if(!isNaN(percentageChange)){
                      const decimals = this.data.find(e => e.id == id).detail
                        .find( el => el.filter == dataFilter).decimals

                      const totalDecimals = (decimals) ? decimals : 2

                        this.data.find(e => e.id == id).detail
                        .find( el => el.filter == dataFilter).value=percentageChange.toFixed(totalDecimals)
                     }

                    if(!isNaN(valueTotal)){

                      const decimals = this.data.find(e => e.id == id).detail
                        .find( el => el.filter == dataFilter).decimals

                      const totalDecimals = (decimals) ? decimals : 2

                      this.data.find(e => e.id == id).detail
                        .find( el => el.filter == dataFilter).valueTotal=valueTotal.toFixed(totalDecimals)
                    }
                  } else {

                    const item = this.data.find(e => e.id == id).detail.find( el => el.filter == dataFilter)

                    if(item.type == 'average'){
                      this.data.find(e => e.id == id).detail
                        .find( el => el.filter == dataFilter).value='noData' // percentageChange.toFixed(2)

                    } else {
                      this.data.find(e => e.id == id).detail
                      .find( el => el.filter == dataFilter).valueTotal='noData' // percentageChange.toFixed(2)
                    }
                  }
                  this.data.find(e => e.id == id).detail
                            .find( el => el.filter == dataFilter).loading=false

            })
        })
    }
  },
};
</script>

<style scoped>
/* Mobile Carousel Styles */
.mobile-carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 10px 0;
}

.carousel-track {
  display: flex;
  transition: transform 0.4s ease-out;
  will-change: transform;
}

.carousel-slide {
  flex: 0 0 100%;
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
}

.mobile-card {
  min-height: calc(100vh - 200px);
  max-height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  background: #1e1e2d;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
}

.card-header-mobile {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 10px;
  flex-shrink: 0;
  color: #fff;
}

.card-content-scroll {
  flex: 1;
  overflow-y: auto;
  padding-right: 5px;
  color: #fff;
}

/* Scrollbar styling for card content */
.card-content-scroll::-webkit-scrollbar {
  width: 4px;
}

.card-content-scroll::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

.card-content-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

.card-content-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Mobile card list styling */
.mobile-card ul {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
}

.mobile-card li {
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 14px;
  color: #fff;
}

.mobile-card li:last-child {
  border-bottom: none;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .mobile-card {
    min-height: calc(100vh - 220px);
    max-height: calc(100vh - 220px);
  }
}
</style>
